import { useContentFeedQuery } from './use-content-feed-query';
import { ContentHomepageModule } from '../../models/home-page-custom/types';

/**
 * Hook that creates a content feed query based on homepage module data
 *
/**
 * Hook that creates a content feed query based on homepage module data
 * 
 * @param contentModule - The homepage module configuration
 * @returns Query response object from useContentFeedQuery
 */
export const useHomepageFeedQuery = ({
  contentModule,
  perPage = 20,
}: {
  contentModule?: ContentHomepageModule;
  perPage?: number;
}) => {
  const {
    source,
    reference_ids,
    display_type: displayType,
    only_include_followed_topics,
    content_inclusion,
  } = contentModule?.attributes.settings || {};

  const filter = (): string | undefined => {
    if (source === 'latest') return 'newest';
    if (source === 'topic') return undefined;
    return source;
  };

  return useContentFeedQuery({
    queryEnabled: !!contentModule,
    filter: filter(),
    perPage: perPage,
    includeTypes: displayType === 'gallery' ? ['image'] : undefined,
    homepageModuleParams: {
      homepage_content_channel_ids:
        source === 'topic' ? reference_ids : undefined,
      homepage_initiative_ids:
        source === 'initiative' ? reference_ids : undefined,
      only_followed_channels:
        only_include_followed_topics === true ? true : undefined,
      content_type:
        content_inclusion && content_inclusion !== 'all'
          ? content_inclusion
          : undefined,
    },
  });
};
